module.exports = __webpack_public_path__ + "fonts/Fontfabric-Mont_Heavy_DEMO.7d90a57.otf";